export default __webpack_public_path__ + "static/media/bol_scan_9.20a0cc70.svg";